const code = 'portal';
const codeGeoportalAPI = 'geoportal';
const codeAPI = 'portal';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
    codeGeoportalAPI: `${codeGeoportalAPI}`,
};